export default {
  locale: state => state.locale,
};



// WEBPACK FOOTER //
// ./src/store/getters.js